import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Music2 } from "lucide-react";
import { StatusBadge, CodeBadge } from "@/components/StatusBadge";
import { CoverImage } from "@/components/CoverImage";
import { t } from "@/i18n";
import { Spotlight, stagger, fadeUp } from "./motion";

export const RecentList = ({ recent }) => {
  const navigate = useNavigate();
  return (
    <Spotlight className="lg:col-span-8 p-6" data-testid="recent-panel">
      <div className="flex items-center justify-between mb-4">
        <div><p className="eyebrow">{t("Catálogo")}</p><h2 className="font-display text-lg font-semibold">{t("Actividad reciente")}</h2></div>
        <Link to="/lanzamientos" className="text-sm text-primary flex items-center gap-1 hover:underline link-arrow" data-testid="link-all-releases">{t("Ver catálogo")} <ArrowRight className="h-3.5 w-3.5" /></Link>
      </div>
      {recent.length === 0 ? (
        <div className="text-center py-12 text-muted-foreground text-sm flex flex-col items-center gap-3" data-testid="empty-recent">
          <span className="h-12 w-12 rounded-2xl bg-muted grid place-items-center"><Music2 className="h-5 w-5 opacity-60" /></span>
          {t("Aún no hay lanzamientos. Crea el primero.")}
        </div>
      ) : (
        <motion.ul variants={stagger} initial="hidden" animate="show" className="divide-y divide-border">
          {recent.map((r) => (
            <motion.li key={r.id} variants={fadeUp} whileHover={{ x: 4 }} transition={{ type: "spring", stiffness: 400, damping: 30 }}
              className="group flex items-center gap-4 py-3 cursor-pointer hover:bg-muted/40 -mx-3 px-3 rounded-lg transition-colors" onClick={() => navigate(`/lanzamientos/${r.id}`)} data-testid={`recent-release-${r.id}`}>
              <div className="relative h-12 w-12 shrink-0 overflow-hidden rounded-md">
                <CoverImage fileId={r.cover_file_id} className="h-12 w-12 transition-transform duration-500 group-hover:scale-110" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-medium truncate group-hover:text-primary transition-colors">{r.title}</p>
                <p className="text-xs text-muted-foreground truncate">{r.artist_name} · {r.release_type} · {t("{n} tracks", { n: r.tracks?.length || 0 })}</p>
              </div>
              <div className="hidden sm:block"><CodeBadge code={r.upc} kind="upc" placeholder="UPC pendiente" /></div>
              <StatusBadge status={r.status} />
              <ArrowRight className="h-4 w-4 text-muted-foreground opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300" />
            </motion.li>
          ))}
        </motion.ul>
      )}
    </Spotlight>
  );
};
